<template>
  <div class="kv-ve-align" role="group" :aria-label="resolvedLabel">
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'left' }"
      :title="resolvedLeftTitle"
      :aria-label="resolvedLeftTitle"
      :aria-pressed="safeValue === 'left' ? 'true' : 'false'"
      @click="set('left')"
    >
      <span class="mdi mdi-format-align-left" aria-hidden="true"></span>
    </button>
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'center' }"
      :title="resolvedCenterTitle"
      :aria-label="resolvedCenterTitle"
      :aria-pressed="safeValue === 'center' ? 'true' : 'false'"
      @click="set('center')"
    >
      <span class="mdi mdi-format-align-center" aria-hidden="true"></span>
    </button>
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'right' }"
      :title="resolvedRightTitle"
      :aria-label="resolvedRightTitle"
      :aria-pressed="safeValue === 'right' ? 'true' : 'false'"
      @click="set('right')"
    >
      <span class="mdi mdi-format-align-right" aria-hidden="true"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: "VeAlignPicker",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: String, default: "left" }, // left | center | right
    label: { type: String, default: "" },
    leftTitle: { type: String, default: "" },
    centerTitle: { type: String, default: "" },
    rightTitle: { type: String, default: "" },
    allowEmpty: { type: Boolean, default: false }, // when true, clicking the active button clears value (inherit)
  },
  computed: {
    resolvedLabel() {
      return this.label || this.t("visual_editor-alignment");
    },
    resolvedLeftTitle() {
      return this.leftTitle || this.t("visual_editor-left");
    },
    resolvedCenterTitle() {
      return this.centerTitle || this.t("visual_editor-center");
    },
    resolvedRightTitle() {
      return this.rightTitle || this.t("visual_editor-right");
    },
    safeValue() {
      const v = String(this.value || "").toLowerCase();
      if (v === "left" || v === "center" || v === "right") return v;
      return this.allowEmpty ? null : "left";
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    set(v) {
      if (this.allowEmpty && this.safeValue === v) {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", v);
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-align {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.kv-ve-align__btn {
  all: unset;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  color: #344054;
}
.kv-ve-align__btn:hover {
  border-color: rgba(42, 170, 76, 0.55);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.12);
}
.kv-ve-align__btn.active {
  border-color: rgba(42, 170, 76, 0.85);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.16);
  background: rgba(42, 170, 76, 0.06);
  color: #027a48;
}
.kv-ve-align__btn .mdi {
  font-size: 18px;
  line-height: 1;
}
</style>


